<template>
	<v-main class="background">
		<router-view></router-view>
	</v-main>
</template>

<script>
export default {};
</script>
